import { getItems, FIG_LISTS } from '../api/figApi';

const START_NUMBER = 1100;

/**
 * Fetch the next invoice number from FIG_Invoices.
 * Parses existing Titles like "FIG-1100", finds the max, increments.
 * Returns "FIG-1100" if the list is empty.
 */
export async function getNextInvoiceNumber(getToken) {
  try {
    const token = await getToken();
    const items = await getItems(token, FIG_LISTS.INVOICES);
    if (items.length === 0) return `FIG-${START_NUMBER}`;

    let max = START_NUMBER - 1;
    for (const item of items) {
      const title = item.Title || '';
      const match = title.match(/^FIG-(\d+)$/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > max) max = num;
      }
    }
    return `FIG-${max + 1}`;
  } catch (err) {
    console.warn('[InvoiceNumber] Failed to fetch invoices — starting at default:', err.message);
    return `FIG-${START_NUMBER}`;
  }
}
